import { api, CACHE_TIME, getHeaders } from '@/api';
import { queryOptions } from '@tanstack/react-query';

import { type WhoAmIResponse } from './schema';

const authEndpoints = {
  getWhoAmI: async (): Promise<WhoAmIResponse | null> => {
    try {
      const { data } = await api.get<WhoAmIResponse>('api/site/whoami', getHeaders());

      return data;
    } catch (error) {
      console.error('Error fetching whoAmI:', error);
      return null;
    }
  }
};

export const authQueries = {
  all: () => ['auth'] as const,
  whoAmI: () =>
    queryOptions({
      queryKey: [...authQueries.all(), 'whoami'],
      queryFn: () => authEndpoints.getWhoAmI(),
      staleTime: CACHE_TIME.STALE,
      gcTime: CACHE_TIME.GC
    })
};

export { authEndpoints };
